export class ProductTypeObject {

    public static readonly PRODUCT = new ProductTypeObject("PRODUCT", 'product');
    public static readonly CFS = new ProductTypeObject("CFS", 'cfs');
    public static readonly RFS = new ProductTypeObject("RFS", 'rfs');
    public static readonly UNKNOWN = new ProductTypeObject("UNKNOWN", '');

    private constructor(public name: string, public urlPath: string) {
    }

    public static createWithType(type: string): ProductTypeObject {
        switch (type) {
            case this.PRODUCT.name:
                return this.PRODUCT;
            case this.CFS.name:
                return this.CFS;
            case this.RFS.name:
                return this.RFS;
            default:
                return this.UNKNOWN;
        }
    }

    public equals(type: ProductTypeObject): boolean {
        return this.name === type.name;
    }
}
